<div>
    <a class="call-to-action-link" [routerLink]="[link]" [queryParams]="queryParams">
        <div
            class="call-to-action"
            [ngStyle]="{
                background: 'url(' + urlImage + ')',
                'background-size': 'cover'
            }"
        >
            <div class="call-to-action-info">
                <h3>{{ title }}</h3>
                <p *ngIf="description">{{ description }}</p>
            </div>
            <button nbButton status="primary">{{ buttonText }}</button>
        </div>
    </a>
</div>
